import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function DialogAlert({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.889 15.2696V12.9851H1.393C0.623599 12.9851 0 12.3567 0 11.5802V1.40571C0 0.629205 0.623617 -0.000244141 1.393 -0.000244141H14.607C15.3764 -0.000244141 16 0.629205 16 1.40571V11.5802C16 12.3567 15.3764 12.9851 14.607 12.9851H9.05236L5.03344 15.8611C4.55516 16.209 3.889 15.8616 3.889 15.2696ZM4.889 12.4809V14.7279L8.60366 12.0696C8.68822 12.0091 8.78933 11.9766 8.893 11.9766H14.607C14.8243 11.9766 15 11.7995 15 11.5802V1.40571C15 1.18605 14.8239 1.00833 14.607 1.00833H1.393C1.17607 1.00833 1 1.18605 1 1.40571V11.5802C1 11.7995 1.17571 11.9766 1.393 11.9766H4.389C4.66514 11.9766 4.889 12.2023 4.889 12.4809ZM8.5001 7.63799V2.36214C8.5001 2.08363 8.27624 1.85785 8.0001 1.85785C7.72396 1.85785 7.5001 2.08363 7.5001 2.36214V7.63799C7.5001 7.9165 7.72396 8.14227 8.0001 8.14227C8.27624 8.14227 8.5001 7.9165 8.5001 7.63799ZM8.0001 10.4489C7.6561 10.4489 7.3771 10.1675 7.3771 9.82054C7.3771 9.47359 7.6561 9.1922 8.0001 9.1922C8.3441 9.1922 8.6231 9.47359 8.6231 9.82054C8.6231 10.1675 8.3441 10.4489 8.0001 10.4489Z'
      />
    </svg>
  );
}
